import { theme, type Theme } from '@chakra-ui/react';

export const breakpoint = (bp: keyof Theme['breakpoints']) =>
    `@media screen and (min-width: ${theme.breakpoints[bp]})`;
